module.exports = __webpack_public_path__ + "img/geoportal-dark.e5b3c3a6.png";